<template>
  <footer class="footer">
      <!-- <template v-if="formFooter">
               <UIButton v-if="isL" size="l" variant="white" label="Написать нам" />
        <CButtonTrigger
          v-if="isL"
          button-title="Написать нам"
          button-variant="white"
          :button-trigger="buttonForm"
        />
        <CSimpleFormBlock
          v-else
          :title="formFooter.form_title"
          :help-text="formFooter.help_text"
          :form-key="formFooter.key"
          :fields="formFooter.fields"
        />
      </template> -->
      <div class="footer__top">
        <div class="wrapper">
           <div class="footer__block">
          <NuxtLink class="footer__logo" :to="{ name: 'home', params: { chapters: 'index' } }">
            <NuxtIcon name="IconHeaderLogo" filled />
          </NuxtLink>
          <ul v-if="config.socials" class="footer__socials">
            <template v-for="item in config.socials">
              <li v-if="item.link.length > 0" :key="item.name" class="footer__socials-item">
                <NuxtLink :to="item.link" class="footer__socials-link" target="_blank">
                  <NuxtIcon v-if="item.name" :name="`IconSocial${item.name}`" filled />
                </NuxtLink>
              </li>
            </template>
          </ul>
        </div>
        <template v-if="affiliates.length > 0">
            <div v-for="affiliate in affiliates" :key="affiliate.id" class="footer__item">
              <a v-if="affiliate.phone" class="footer__link footer__link--phone" :href="`tel:${affiliate.phone}`" @click="goalsClickPhone">
                {{ affiliate.phone}}
              </a>
              <span v-if="affiliate.title" class="footer__link">
                <NuxtIcon name="IconMetro" />
                {{ affiliate.title }}
              </span>
              <span v-if="affiliate.working_time" class="footer__link">
                <NuxtIcon name="IconClock" filled />
                {{ affiliate.working_time }}
              </span>
              <span v-if="affiliate.address" class="footer__link">
                <NuxtIcon name="IconMapPin" filled />
                {{ affiliate.address }}
              </span>
            </div>
        </template>
        <div v-if="config?.footerText" v-html="config?.footerText" class="footer__text"></div>
        </div>

      </div>

      <div class="footer__middle">
        <div class="wrapper">

          <div v-for="(item, index) in menuItems" :key="`footer_menu_${index}`" class="footer-box">
            <span class="footer-box__title">{{ item.title }}</span>
             <ul v-if="item.children.length" class="footer-box__list">
                <li v-for="(child, index) in item.children" :key="`footer_menu_${index}`" class="footer-box__item">
                  <NuxtLink
                    :to="
                      child.type === 'direct_link'
                        ? child.url
                        : { name: 'home', params: { chapters: child.slug.split('/') } }
                    "
                    class="footer-box__link"
                    :target="child.target"
                  >
                    {{ child.title }}
                  </NuxtLink>
                </li>
            </ul>
          </div>

          <div v-if="config?.writeToManagementEmail" class="footer__item">
            <span v-if="config?.writeToManagementText">{{ config?.writeToManagementText }}</span>
            <a :href="`mailto:${config?.writeToManagementEmail}`" class="footer__link">{{ config?.writeToManagementEmail }}</a>
          </div>
        </div>

      </div>

      <div class="footer__bottom">
        <div class="wrapper">
          <div class="footer__content">
             <div v-if="config?.contraidicationText" v-html="config?.contraidicationText"></div>
              <NuxtLink
                v-if="config?.mapLinkFooter"
                :to="{ name: 'home', params: { chapters: useSlugTransform(config?.mapLinkFooter) } }"
                class="footer__bottom-link"
              >
                Карта сайта
              </NuxtLink>
              <NuxtLink
                v-if="config.privacyPolicy"
                :to="{ name: 'home', params: { chapters: useSlugTransform(config.privacyPolicy) } }"
                class="footer__bottom-link"
              >
                Политика конфиденциальности
              </NuxtLink>
              <NuxtLink
                v-if="config?.licenseLink"
                :to="{ name: 'home', params: { chapters: useSlugTransform(config?.licenseLink) } }"
                class="footer__bottom-link"
              >
                Лицензии и юридическая информация
              </NuxtLink>
              <NuxtLink
                v-if="config?.agreementLink"
                :to="{ name: 'home', params: { chapters: useSlugTransform(config?.agreementLink) } }"
                class="footer__bottom-link"
              >
                Пользовательское соглашение
              </NuxtLink>
          </div>

          <NuxtLink class="footer__bottom-link footer__coffee" to="https://coffeestudio.ru/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 32" width="18" height="15" style="vertical-align:middle;margin-right:4px;"><path fill="currentColor" d="M5.1 32C3 28.5 2.3 27.3 1.8 25.8C.7 23 0 19.4 0 16.2C0 13.3.4 10.3 1.3 7.8C2.2 5.2 3 3.5 5.2 0H11.6C8.9 4 8 5.9 7.1 8.9C6.5 11.2 6.1 13.7 6.1 16C6.1 19.3 6.8 22.8 8 25.6C8.7 27.4 9.5 28.8 11.6 32H5.1Z"/><path fill="currentColor" d="M24 0C22.3 1.4 19.4 5 19.4 9.6C19.4 13.2 24.1 18.4 24.1 22.2C24.1 26.8 22.4 29 18.5 32H13.2C15.9 30 19.7 25.4 16.8 18.8C15.2 15.2 13.2 13.7 13.2 9.6C13.2 4.9 16.3 1.9 18.7 0H24Z"/><path fill="currentColor" d="M25.6 32C28.4 27.7 29.4 25.9 30.2 23C30.8 20.7 31.1 18.2 31.1 15.7C31.1 12.6 30.4 8.9 29.1 6.1C28.3 4.3 27.6 2.9 25.6 0H32.1C34.4 3.8 35.3 5.7 36.2 8.6C36.9 11.1 37.2 13.4 37.2 16C37.2 19.4 36.5 23 35.4 25.8C34.8 27.3 34.1 28.5 32.1 32H25.6Z"/></svg>сайты для медицины</NuxtLink>
        </div>
      </div>

  </footer>
</template>

<script setup lang="ts">
import type { MenuItem } from '@/types/menu';
import './styles.scss';
import { useScreenWidth } from '~/composables/useScreenWidth';
import CSimpleFormBlock from '~/components/blocks/simpleFormBlock/CSimpleFormBlock.vue';
import { useSlugTransform, useState } from '#imports';
import type { BlockButtonTrigger, FormModel } from '~/types/pages';
import CButtonTrigger from '~/components/buttonTrigger/CButtonTrigger.vue';
import { yandexRichGoals } from '~/composables/yandexRichGoals';

interface Props {
  menuItems: MenuItem[];
  footerPhone?: string;
  footerEmail?: string;
}

const formFooter: FormModel | undefined = useState<FormModel[]>('forms').value?.find(
  el => el.key === '2fields',
);

const { goalsClickPhone } = yandexRichGoals();

const config = useState('config');

const affiliates = useState('affiliates');

defineProps<Props>();

const { isL } = useScreenWidth();

const buttonForm: BlockButtonTrigger = {
  type: 'form',
  content: '2fields',
};
</script>
